export default {
  card: {
    textAlign: 'center',
  },
  icon: {
    textSize: '18rem',
  },
}
